<template>
    <div>
        <el-dialog :visible="visible" :modal-append-to-body="false" class="ah-detail-dialog update-401-status-dialog" append-to-body :before-close="onClose">
            <template slot="title"> 編輯 </template>
            <el-form ref="form" :model="form" class="detail-row">
                <el-form-item label="申報狀態" prop="type">
                    <el-select v-model="form.type" placeholder="請選擇">
                        <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-button type="" @click="onClose">取消</el-button>
                <el-button type="primary" :loading="isLoading" :disabled="!form.type" @click="onSubmit">
                    確定
                </el-button>
            </el-form>
        </el-dialog>
        <DeclareChangeHintDialog :visible="hintVisible" @confirmed="onHintConfirmed" />
    </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
import DeclareChangeHintDialog from '@/components/dashboard/Accounting/BusinessTax/DeclareChangeHintDialog.vue';

export default {
    components: { DeclareChangeHintDialog },
    props: {
        visible: Boolean,
        target: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        ...mapState({
            selectedItems: (state) => state.businessTax.selectedItems,
        }),
        typeList() {
            if (this.isTargetIncome) {
                return [
                    {
                        label: '未申報',
                        value: 'undeclared',
                    },
                ];
            }
            return [
                {
                    label: '未申報',
                    value: 'undeclared',
                },
                {
                    label: '不申報扣抵',
                    value: 'not-declare',
                },
            ];
        },
        isTargetIncome() {
            return !!this.target?.ioo || !!this.target?.tioo;
        },
    },
    data() {
        return {
            form: { type: null },
            isLoading: false,

            hintVisible: false,
        };
    },
    methods: {
        ...mapMutations({
            onClearSelection: 'businessTax/onClearSelection',
        }),
        ...mapActions({
            updateDeclaredData: 'businessTax/updateDeclaredData',
        }),
        async onSubmit() {
            this.isLoading = true;
            try {
                await this.onMarkUndeclared();
                this.updateDeclaredData();
                this.onClearSelection();
                this.onClose();
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        onHintConfirmed(val) {
            this.hintVisible = false;
            if (val) this.onSubmit();
        },
        async onMarkUndeclared() {
            try {
                const snos = _.map([this.target], (o) => ({
                    sno: o.sno,
                    typ: o.typ,
                    isTranInovice: o.isTranInovice,
                    taxCredited: o.taxCredited,
                }));

                if (this.isTargetIncome) {
                    const INVOICE_LIST = _.chain(snos)
                        .filter((o) => !o.isTranInovice)
                        .map((o) => ({
                            sno: o.sno,
                            declareStatus: false,
                            updateType: o.typ > 0 ? 1 : 2,
                        }))
                        .value();

                    const TRAN_INVOICE_LIST = _.chain(snos)
                        .filter((o) => o.isTranInovice)
                        .map((o) => ({
                            sno: o.sno,
                            declareStatus: false,
                            updateType: o.typ > 0 ? 1 : 2,
                        }))
                        .value();

                    await this.$api({
                        url: 'AccountingSummaryPage/UpdateInvoice401DeclareStatus',
                        data: { invoices: INVOICE_LIST, invoiceType: 1 },
                        method: 'POST',
                    });
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdateInvoice401DeclareStatus',
                        data: { invoices: TRAN_INVOICE_LIST, invoiceType: 2 },
                        method: 'POST',
                    });
                } else {
                    const TCIN_LIST = _.chain(snos)
                        .filter((o) => o.taxCredited)
                        .map((o) => ({
                            sno: o.sno,
                            declareStatus: this.form.type === 'undeclared' ? 0 : 2,
                        }))
                        .value();
                    const NON_TCIN_LIST = _.chain(snos)
                        .filter((o) => !o.taxCredited)
                        .map((o) => ({
                            sno: o.sno,
                            declareStatus: this.form.type === 'undeclared' ? 0 : 2,
                        }))
                        .value();

                    await this.$api({
                        url: 'AccountingSummaryPage/UpdatePaymentInvoiceDeclareStatus',
                        data: { payments: TCIN_LIST },
                        method: 'POST',
                    });
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayment401DeclareStatus',
                        data: { payments: NON_TCIN_LIST },
                        method: 'POST',
                    });
                }
            } catch (e) {
                console.log(e);
            }
        },
        onClose() {
            this.form.type = null;
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.update-401-status-dialog {
    display: flex;
    .el-dialog {
        width: 100%;
        max-width: 550px;
        margin: auto !important;
    }
}
</style>
